import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { AwsAuthService } from '@nx/auth';
import { forkJoin, from, Observable } from "rxjs";
import { take, map, concatMap } from 'rxjs/operators';
import { Topic } from "../../topic-player/interfaces/topic.interface";
import { TopicService } from "../../topic-player/services/topic.service";
import { TopicAttempt } from "../../topic-player/interfaces/topic-attempt.interface";

@Injectable({
  providedIn: 'root'
})

export class TopicsResolver  {

  constructor(private topicService: TopicService, private awsAuthService: AwsAuthService, @Inject(LOCALE_ID) private localeId: string) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const slug = route.params['subject-slug'];
    return from(this.awsAuthService.isUserLoggedIn()).pipe(concatMap(isLoggedIn => {
      if(isLoggedIn) {
        const availableTopics = this.topicService.getTopicsBySubjectAndLocale(slug, this.localeId).pipe(take(1));
        const completedTopics = this.topicService.getTopicsAttemptsByCompleted(true).pipe(take(1));
        return forkJoin([availableTopics, completedTopics]).pipe(map(([available, completed]) => this.addCompletedProperty(available, completed)));
      } else {
        return this.topicService.getTopicsBySubjectAndLocale(slug, this.localeId);
      }
    }));
  }

  private addCompletedProperty(availableTopics: Topic[], completedTopics: TopicAttempt[] ) {
    const completedTopicsNames: string[] = [];
    completedTopics.forEach((topic: TopicAttempt) => {
      completedTopicsNames.push(topic.SK.split(':')[1])
    });
    return availableTopics.map((topic:Topic) => {
      topic.completed = completedTopicsNames.indexOf(topic.sk) >= 0;
      return topic;
    });
  }
}